import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { Phases_getInstance3nx89wd8botnl as Phases_getInstance_0 } from '../statement/HttpResponsePipeline.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { observable2pw4p3n7s3klf as observable } from '../utils/ByteChannelUtils.mjs';
import { replaceResponse3ut5eo3odxj99 as replaceResponse } from '../call/DelegatedCall.mjs';
import {
  ObservableContent3ft2pt0w2oysd as ObservableContent,
  ProgressListener886sg277haqw as ProgressListener,
} from '../content/ObservableContent.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_UploadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return UploadProgressListenerAttributeKey;
}
var UploadProgressListenerAttributeKey;
function get_DownloadProgressListenerAttributeKey() {
  _init_properties_BodyProgress_kt__s0v569();
  return DownloadProgressListenerAttributeKey;
}
var DownloadProgressListenerAttributeKey;
function get_BodyProgress() {
  _init_properties_BodyProgress_kt__s0v569();
  return BodyProgress;
}
var BodyProgress;
var AfterRenderHook$install$slambdaClass;
function AfterRenderHook$install$slambda() {
  if (AfterRenderHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.a5o_1 = $handler;
      }
      *k5h($this$intercept, content, $completion) {
        if (!(content instanceof OutgoingContent()))
          return Unit_instance;
        var tmp0_elvis_lhs = yield* this.a5o_1($this$intercept.z4s_1, content, $completion);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var newContent = tmp;
        yield* $this$intercept.b4s(newContent, $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.k5h(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    AfterRenderHook$install$slambdaClass = $;
  }
  return AfterRenderHook$install$slambdaClass;
}
function AfterRenderHook$install$slambda_0($handler) {
  var i = new (AfterRenderHook$install$slambda())($handler);
  var l = ($this$intercept, content, $completion) => i.k5h($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
var AfterRenderHookClass;
function AfterRenderHook() {
  if (AfterRenderHookClass === VOID) {
    class $ {
      b5o(client, handler) {
        var observableContentPhase = new (PipelinePhase())('ObservableContent');
        client.r5h_1.a4t(Phases_getInstance().f5o_1, observableContentPhase);
        client.r5h_1.d4t(observableContentPhase, AfterRenderHook$install$slambda_0(handler));
      }
      h5o(client, handler) {
        return this.b5o(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'AfterRenderHook');
    AfterRenderHookClass = $;
  }
  return AfterRenderHookClass;
}
var AfterRenderHook_instance;
function AfterRenderHook_getInstance() {
  return AfterRenderHook_instance;
}
var AfterReceiveHook$install$slambdaClass;
function AfterReceiveHook$install$slambda() {
  if (AfterReceiveHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.i5o_1 = $handler;
      }
      *j5o($this$intercept, response, $completion) {
        var newResponse = yield* this.i5o_1(response, $completion);
        if (!(newResponse == null)) {
          yield* $this$intercept.b4s(newResponse, $completion);
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.j5o(tmp, p2 instanceof HttpResponse() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    AfterReceiveHook$install$slambdaClass = $;
  }
  return AfterReceiveHook$install$slambdaClass;
}
function AfterReceiveHook$install$slambda_0($handler) {
  var i = new (AfterReceiveHook$install$slambda())($handler);
  var l = ($this$intercept, response, $completion) => i.j5o($this$intercept, response, $completion);
  l.$arity = 2;
  return l;
}
var AfterReceiveHookClass;
function AfterReceiveHook() {
  if (AfterReceiveHookClass === VOID) {
    class $ {
      k5o(client, handler) {
        var tmp = Phases_getInstance_0().n5o_1;
        client.u5h_1.d4t(tmp, AfterReceiveHook$install$slambda_0(handler));
      }
      h5o(client, handler) {
        return this.k5o(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'AfterReceiveHook');
    AfterReceiveHookClass = $;
  }
  return AfterReceiveHookClass;
}
var AfterReceiveHook_instance;
function AfterReceiveHook_getInstance() {
  return AfterReceiveHook_instance;
}
function withObservableDownload(_this__u8e3s4, listener) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = _this__u8e3s4.l5k();
  return replaceResponse(tmp, VOID, ($this$replaceResponse) => observable($this$replaceResponse.t5k(), $this$replaceResponse.dw(), contentLength($this$replaceResponse), listener)).e5i();
}
function BodyProgress$lambda($this$createClientPlugin) {
  _init_properties_BodyProgress_kt__s0v569();
  var tmp = AfterRenderHook_instance;
  $this$createClientPlugin.t5o(tmp, BodyProgress$lambda$slambda_0());
  var tmp_0 = AfterReceiveHook_instance;
  $this$createClientPlugin.t5o(tmp_0, BodyProgress$lambda$slambda_2());
  return Unit_instance;
}
var BodyProgress$lambda$slambdaClass;
function BodyProgress$lambda$slambda() {
  if (BodyProgress$lambda$slambdaClass === VOID) {
    class $ {
      *u5o(request, content, $completion) {
        var tmp0_elvis_lhs = request.s5j_1.m4n(get_UploadProgressListenerAttributeKey());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var listener = tmp;
        return new (ObservableContent())(content, request.r5j_1, listener);
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE();
        return this.u5o(tmp, p2 instanceof OutgoingContent() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    BodyProgress$lambda$slambdaClass = $;
  }
  return BodyProgress$lambda$slambdaClass;
}
function BodyProgress$lambda$slambda_0() {
  var i = new (BodyProgress$lambda$slambda())();
  var l = (request, content, $completion) => i.u5o(request, content, $completion);
  l.$arity = 2;
  return l;
}
var BodyProgress$lambda$slambdaClass_0;
function BodyProgress$lambda$slambda_1() {
  if (BodyProgress$lambda$slambdaClass_0 === VOID) {
    class $ {
      *v5o(response, $completion) {
        var tmp0_elvis_lhs = response.l5k().e5k().f5k().m4n(get_DownloadProgressListenerAttributeKey());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var listener = tmp;
        return withObservableDownload(response, listener);
      }
      ld(p1, $completion) {
        return this.v5o(p1 instanceof HttpResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    BodyProgress$lambda$slambdaClass_0 = $;
  }
  return BodyProgress$lambda$slambdaClass_0;
}
function BodyProgress$lambda$slambda_2() {
  var i = new (BodyProgress$lambda$slambda_1())();
  var l = (response, $completion) => i.v5o(response, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_BodyProgress_kt_pmfrhr;
function _init_properties_BodyProgress_kt__s0v569() {
  if (!properties_initialized_BodyProgress_kt_pmfrhr) {
    properties_initialized_BodyProgress_kt_pmfrhr = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'UploadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(ProgressListener());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(ProgressListener()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    UploadProgressListenerAttributeKey = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'DownloadProgressListenerAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(ProgressListener());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(ProgressListener()), arrayOf([]), false);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_2, tmp$ret$2_0);
    DownloadProgressListenerAttributeKey = new (AttributeKey())(name_0, tmp$ret$1_0);
    BodyProgress = createClientPlugin('BodyProgress', BodyProgress$lambda);
  }
}
//region block: init
AfterRenderHook_instance = new (AfterRenderHook())();
AfterReceiveHook_instance = new (AfterReceiveHook())();
//endregion
//region block: exports
export {
  get_BodyProgress as get_BodyProgresstom4nhodv8bj,
};
//endregion

//# sourceMappingURL=BodyProgress.mjs.map
